import { Component,OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { User } from '../models';
import { UserService, AuthenticationService, DealerService, SpinnerService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { trigger, state, style, transition, animate } from '@angular/animations';
//import { validateConfig } from '@angular/router/src/config';
import { Subscription } from 'rxjs/Subscription';
import { Dealer, DealerSourceMapping } from '../models';
import { filter, pairwise } from 'rxjs/operators';
import { LeftmenuLayoutComponent } from '../layouts/leftmenu-layout.component';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { timer } from 'rxjs/observable/timer';
import { Observable } from 'rxjs/Observable';
// import { SelectItem } from 'primeng/primeng';
import * as moment from 'moment';
import { GenericValidator } from '../shared/generic-validator';
import { DatePipe } from '@angular/common';

@Component({
    templateUrl: 'edit-subscriber.component.html',
    providers: [DatePipe]
})
export class EditSubscriberComponent {
    users: User[] = [];
    private subscription: Subscription = new Subscription();
    private sub: Subscription;
    dealers: any[];
    dealerCols: any;
    masterdealerCols: any;
    dealerSourceCols: any;
    Status: any;
    customMessage: any;
    public syncTopMenuClick: boolean = true;
    isFilelogsEnabled: boolean;
    isRed: boolean;
    searchText: any;
    searchDealers: boolean;
    topMenuBar: boolean;
    DealerGuid: any;
    editForm: FormGroup;
    pageTitle: any;
    isShowSource: boolean;
    dealerlst: any;
    clients: any;
    sourceTypes: any;
    fileTypes: any;
    SubscripitonName: any;
    selectedDealers: any;
    months: any;
    day: any;
    every_weekend: any;
    every_day: any;
    end_date: any;
    start_date: any;
    Scheduleoptional: any;
    data: any;
    source: any;
    client: any;
    source_type: any;
    validationmsg: boolean = false;
    oneTimevalidationmsg: boolean;
    dailySchedulevalidationmsg: boolean;
    monthlySchedulevalidationmsg: boolean;
    currentUser: User;
    Sales: any;
    Service: any;
    Appointment: any;
    selectedData: any[] = [];
    listData: any;
    dailyschedule: any;
    Everyweekday: boolean = false;
    Everyday: boolean = false;
    msgSuccess: boolean;
    Message: string;
    timer: any;
    msgclass: string;
    selectedDataName: any[] = [];
    listDataNames: string;
    ClientSubscriptionGuid: string;
    sclient: any;
    selectedDealerlst: any;
    CheckedFileTypes: any[] = [];
    showFiletypes: boolean = false;
    ScheduleType: any;
    selectedType: string;
    divDaily: boolean = true;
    divWeekly: boolean = false;
    divMonthly: boolean = false;
    selectedDailySchedule: string;
    selectedWklyWeekDays: string[];
    selectedMonths: string[];
    FinalDeliveryOptions: any;
    selectedDlyWeekDays: any;
    isMonthCheckValid: boolean;
    WeekDays: any;
    TimeFormat: Object;
    validationMessages: { [key: string]: { [key: string]: string } };
    genericValidator: any;
    displayMessage: { [key: string]: string } = {};
    delivaryoptions: string;
    selectedDayOfMonth: any;
    selectedrepeatEveryWk: any;
    selecteddayOfMonth: any;
    NoOfDays: string;
    Months: any;
    selectedTime: string;
    divOneTime: boolean;
    DateRangeOptions: any[]=[];
    isCustomDate: boolean = false;
    today: any;
    pastDate: any;
    sources: any;
    onetimeerrormsg: string ='';
    mastersourceTypes: any;
    sourceType: any;
    constructor(private userService: UserService,
        private dealerService: DealerService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private spinnerService: SpinnerService,
        private ngxPermissionsService: NgxPermissionsService,
        private authenticationService: AuthenticationService,
        private datePipe: DatePipe,
        private http: HttpClient) { 
            authenticationService.topMenuBar.subscribe(value => {
                this.syncTopMenuClick = !value;
            });
            this.today = new Date();
            this.pastDate = new Date();
            this.today = this.datePipe.transform(this.today, 'yyyy-MM-dd');
            this.pastDate = this.datePipe.transform(this.pastDate.setDate(this.pastDate.getDate() - 1825), 'yyyy-MM-dd');
            this.WeekDays = [];
            this.TimeFormat = [];
            this.ScheduleType = [];
            this.validationMessages = {
                startDate: {
                    required: 'Start Date is required.'
                },
                DailySchedule: {
                    required: 'Please select DailySchedule.'
                },
                afterdays: {
                    required: 'Please enter afterdays.'
                },
                Fwd: {
                    required: 'Please select a Day'
                },
                Wds: {
                    required: 'Please select a day in Week'
                },
                Ms: {
                    required: 'Please select a Month'
                },
                error: {
                    required: 'Error'
                }
            };
            // Define an instance of the validator for use with this form, 
            // passing in this form's set of validation messages.
            this.genericValidator = new GenericValidator(this.validationMessages);
    
        }
    ngOnInit() {
        this.spinnerService.start();
        this.isFilelogsEnabled = false;
        this.isRed = true;
        this.searchText = null;
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.GetDeliveryOptionsDefaultJSON();
        this.ScheduleTypeInitialize();
       this.WeekDaysInitialize();
       //this.TimeInitialize();
       this.MonthsInitialize();
       this.dateRangeGet();
       this.editForm = this.fb.group({
            SubscripitonName: ['', [Validators.required]],
            client: ['', [Validators.required]],
            SourceType: ['', Validators.required],
            Source: [''],
            Scheduleoptional: [''],
            selectedDealers:['', Validators.required],
            data:[''],
            start_date:[''],
            end_date:[''],
            day:[''],
            months:[''],
            ClientFileType:['',[Validators.required]],
            startDate: [''],
            endDate: [''],
            DailySchedule: [''],
            afterdays: [0],
            repeatEveryWk: [''],
            Hour: ['06'],
            Mins: ['00'],
            dayOfMonth: ['1'],
            DayOfMonth: [''],
            Fwd: [[]],
            Wds: [[]],
            Ms: [[]],
            CommonMediaTypeId: ['', null],
            custom_date:[''],
            DateRange:['']
        });
        
       this.sub = this.route.params.subscribe(
            params => {
                this.ClientSubscriptionGuid = params['guid'];
            }
        );
        this.getClients();
        this.getDataSource();
        this.getSourceTypes();
    }
    mappdealerdata(data){
        this.selectedDealerlst = "[";
            let i=1
            for (let d of data.MappedDealers) {
                
                if(i == data.MappedDealers.length){
                    this.selectedDealerlst = this.selectedDealerlst+d.ParentDealerId;
                }else{
                    this.selectedDealerlst = this.selectedDealerlst+d.ParentDealerId+',';
                }
                i++;
            }
           this.selectedDealerlst = JSON.parse(this.selectedDealerlst+"]");

    }
    GetDlrData(source_id,file_type_id,mappedDealers = null) {
        this.spinnerService.start();
        if(source_id == '' || source_id == null ){
            source_id = 0;
        }
        if(file_type_id != '' && file_type_id != undefined){
            this.dealerService.getMasterDealers(source_id,file_type_id).pipe(first()).subscribe(dealers => {
                this.dealerlst = [];
                for (let d of dealers) {
                    this.dealerlst.push({ label: d.NaturalKey +' - '+ d.DealerName, value: d.ParentDealerId });
                }
                if(mappedDealers != null){
                    this.mappdealerdata(mappedDealers);
                }
                if(this.dealerlst.length == dealers.length){
                    this.spinnerService.stop();
                }
                
            }),
            error => {
                this.spinnerService.stop();
            };
        }else{
            this.spinnerService.stop();
        }
        
      }
    getSubscriptionDetails(ClientSubscriptionGuid){
        this.dealerService.getSubscriptionById(ClientSubscriptionGuid).pipe(first()).subscribe(data => {
            this.GetDlrData(data.DataSourceId,data.FileTypeId,data);
            this.getFileTypes(data.ClientId.toString());
            if( data.SubscriptionTypeId == 2 ||  data.SubscriptionTypeId == 3){
                this.isShowSource = true; 
            }else{
                this.isShowSource = false; 
            }
            if (data.ScheduleOptions != null && data.ScheduleOptions != '') {
                this.FinalDeliveryOptions = JSON.parse(data.ScheduleOptions);                   
               
                this.selectedTime = this.FinalDeliveryOptions.Time ? moment(this.FinalDeliveryOptions.Time, 'hh:mm:ss A').format("A") : "AM";
                this.selectedType = this.ScheduleType.find(i => i.value == this.FinalDeliveryOptions.FrequencyOptions.Frequency).value;
                if (this.FinalDeliveryOptions.DailySchedule.FollowingDays.IsSelected) {
                    this.selectedDlyWeekDays = this.FinalDeliveryOptions.DailySchedule.FollowingDays.Days;
                    this.FinalDeliveryOptions.DailyScheduleType = 'followingDays';
                    this.NoOfDays = '';
                }
                else if (this.FinalDeliveryOptions.DailySchedule.EveryWeekday.IsSelected) {
                    this.FinalDeliveryOptions.DailyScheduleType = 'everyWeekday';
                }
                else if (this.FinalDeliveryOptions.DailySchedule.NumberofDays.IsSelected) {
                    this.FinalDeliveryOptions.DailyScheduleType = 'noOfdays';
                }
                this.selectedWklyWeekDays = this.FinalDeliveryOptions.WeeklySchedule.WeekDay;
                this.selectedMonths = this.FinalDeliveryOptions.MonthlySchedule.Months;
                this.FinalDeliveryOptions.DayOfMonth = 'DayOfMonth';

                if (this.selectedType === 'OneTime') {
                    this.divDaily = false;
                    this.divWeekly = false;
                    this.divMonthly = false;
                    this.divOneTime = true;
                }
                if (this.selectedType === 'Daily') {
                    this.divDaily = true;
                    this.divWeekly = false;
                    this.divMonthly = false;
                    this.divOneTime = false;
                }
                if (this.selectedType === 'Weekly') {
                    this.divDaily = false;
                    this.divWeekly = true;
                    this.divMonthly = false;
                    this.divOneTime = false;
                }
                if (this.selectedType === 'Monthly') {
                    this.divDaily = false;
                    this.divWeekly = false;
                    this.divMonthly = true;
                    this.divOneTime = false;
                }
                if(data.ClientId == 1){
                     this.sourceTypes = this.sourceTypes.filter(j=>(j.SubscriptionTypeName != 'Custom' && j.SubscriptionTypeName != 'Raw'))
                 }else if(data.ClientId == 2 || data.ClientId == 3){
                     this.sourceTypes = this.sourceTypes.filter(j=>(j.SubscriptionTypeName != 'Master' && j.SubscriptionTypeName != 'Raw'))
                 }else if(data.ClientId == 4 ){
                     this.sourceTypes = this.sourceTypes.filter(j=>(j.SubscriptionTypeName != 'Custom' && j.SubscriptionTypeName != 'Master'))
                 }
                this.editForm.patchValue({
                    //startDate: this.FinalDeliveryOptions.StartDate,
                    //endDate: this.FinalDeliveryOptions.EndDate,
                    DailySchedule: this.FinalDeliveryOptions.DailyScheduleType,
                    Fwd: this.FinalDeliveryOptions.DailySchedule.FollowingDays.Days,
                    afterdays: this.FinalDeliveryOptions.DailySchedule.NumberofDays.Days,
                    repeatEveryWk: this.FinalDeliveryOptions.WeeklySchedule.RepeatEveryWk,
                    dayOfMonth: this.FinalDeliveryOptions.MonthlySchedule.DayOfMonth.IsSelected ? this.FinalDeliveryOptions.MonthlySchedule.DayOfMonth.NoDays : '',
                    DayOfMonth: this.FinalDeliveryOptions.DayOfMonth,
                    Hour: this.FinalDeliveryOptions.Time ? moment(this.FinalDeliveryOptions.Time, 'hh:mm:ss A').format("hh") : "06",
                    Mins: this.FinalDeliveryOptions.Time ? moment(this.FinalDeliveryOptions.Time, 'hh:mm:ss A').format("mm") : "00",
                });
                this.setscheduleOptions();
            }
            this.isCustomDate = false;
            if(data.DateRange == 'CustomDate'){
                this.isCustomDate = true;
                let custom_date = moment(data.CustomDate).format("YYYY-MM-DD");
                this.editForm.patchValue({
                    custom_date:custom_date
                });
            }
            this.editForm.patchValue({
                SubscripitonName: data.SubscriptionName,
                client: data.ClientId.toString(),
                SourceType: data.SubscriptionTypeId.toString(),
                Source: data.DataSourceId,
                ClientFileType:data.FileTypeId.toString(),
                DateRange:data.DateRange,
            });
           
            this.spinnerService.stop();
        });
    }
    onChangeSelection(value)
    {
        if( value =="Master")
        { this.GetDlrData(null,this.editForm.value.ClientFileType); this.isShowSource = false; }
        else{this.isShowSource = true;}
    }
    bindDealerInfo() {
        if (this.searchText != "") {
            this.searchDealers = true;
        }
    }
    Leftmenuclick() {
        this.topMenuBar = !this.topMenuBar;
        this.authenticationService.topMenuBar.next(this.topMenuBar);
    }
    getClients(){
        this.dealerService.getClients().pipe(first()).subscribe(clients => {
                
            this.clients  = clients;
            if (this.ClientSubscriptionGuid != '0') {
                this.pageTitle = "Edit Subscription";
                this.getSubscriptionDetails(this.ClientSubscriptionGuid);
            }
            else {
                this.pageTitle = "Add Subscription";
            }
        });
    }
    getDataSource(){
        this.dealerService.getDataSource().pipe(first()).subscribe(result => {
            this.sources  = result;
            this.spinnerService.stop();
        });
    }
    getSourceTypes(){
        this.dealerService.getSourceTypes().pipe(first()).subscribe(SourceTypes => {
            this.sourceTypes  = SourceTypes;
            this.mastersourceTypes  = SourceTypes;
            this.spinnerService.stop();
        });
    }
    getFileTypes(client_id){
        this.showFiletypes = false;
        this.dealerService.getFileTypes(client_id).pipe(first()).subscribe(FileTypes => {
            this.showFiletypes = true;
            this.fileTypes  = FileTypes;
            this.spinnerService.stop();
        });
    }
  
    clicktogetdealer(){
        if(this.editForm.value.ClientFileType != ''){
            this.GetDlrData(this.editForm.value.Source,this.editForm.value.ClientFileType);
        }
    }
    clickweekday(){
        this.Everyweekday = true;
        this.Everyday = false;
    }
    clickEveryday(){
        this.Everyday = true;
        this.Everyweekday = false;
    }
    submitSubscription(){
        this.spinnerService.start();
        if (this.editForm.valid) {
            if (this.editForm.dirty) {
                if(this.selectedType == 'OneTime'){
                    if(this.editForm.value.DateRange.length == 0){
                        // this.onetimeerrormsg = 'Please select date range';
                        this.onetimeerrormsg = '';
                    }else{
                        this.onetimeerrormsg = '';
                    }
                }
                if((this.editForm.value.selectedDealers != 0 && this.editForm.value.selectedDealers != undefined) && this.onetimeerrormsg == ''){
                    this.fileTypes.filter(c=>c.FileTypeid == this.editForm.value.ClientFileType);
                    let mdlr = Object.assign({}, this.editForm.value);
                    mdlr.ClientId = this.editForm.value.client;
                    mdlr.SubscriptionTypeId = this.editForm.value.SourceType;
                    //mdlr.ScheduleOptions = schedulejson;
                    mdlr.DataSourceId = this.editForm.value.Source;
                    mdlr.SubscriptionName = this.editForm.value.SubscripitonName;
                    mdlr.DealerIds = this.editForm.value.selectedDealers.toString();
                    mdlr.CreatedBy = this.currentUser.userName;
                    mdlr.UpdatedBy = this.currentUser.userName;
                    mdlr.FileTypeId = this.editForm.value.ClientFileType;
                    mdlr.FileTypes = this.fileTypes[0].FileTypeName;
                    let scheduleType = 'Recurring';
                    if(this.selectedType == 'OneTime'){
                        scheduleType = 'OneTime';
                        mdlr.CustomDate = this.editForm.value.custom_date;
                        mdlr.DateRange = this.editForm.value.DateRange;
                    }
                    mdlr.ScheduleType = scheduleType;
                    this.setscheduleOptions();
                    this.ScheduleSec();
                    mdlr.ScheduleOptions = JSON.stringify(this.FinalDeliveryOptions);
                    if(this.ClientSubscriptionGuid == '0'  || this.ClientSubscriptionGuid == '' || this.ClientSubscriptionGuid == null || this.ClientSubscriptionGuid == undefined){
                        this.save(mdlr);
                    }else{
                       mdlr.ClientSubscriptionGuid = this.ClientSubscriptionGuid;
                       this.updateSubscripiton(mdlr);
                    }
                }else{
                    this.spinnerService.stop();
                }
            }else{
                this.spinnerService.stop();
            }
        }else{
            this.spinnerService.stop();
            this.validationmsg = true;
        }
    }
    save(mdlr) {
        this.dealerService.SaveSubscription(mdlr).pipe(first()).subscribe(data => {
            this.msgclass = 'text-success';
            this.msgSuccess = true;
            this.Message = "Saved Successfully.";
            this.spinnerService.stop();
            this.timer = timer(1000, 1000);
            this.subscription.add(this.timer.subscribe(t =>
                this.router.navigate(['/subscriptions/managesubscriptions'])));

        })
        error => {
            this.msgclass = 'text-danger';
            this.msgSuccess = true;
            this.Message = "Something went wrong.";
            this.spinnerService.stop();
        };
    }
    updateSubscripiton(mdlr) {
        this.dealerService.updateSubscription(mdlr).pipe(first()).subscribe(data => {
            this.msgclass = 'text-success';
            this.msgSuccess = true;
            this.Message = "Saved Successfully.";
            this.spinnerService.stop();
            this.timer = timer(1000, 1000);
            this.subscription.add(this.timer.subscribe(t =>
                this.router.navigate(['/subscriptions/managesubscriptions'])));
        })
        error => {
            this.msgclass = 'text-danger';
            this.msgSuccess = true;
            this.Message = "Something went wrong.";
            this.spinnerService.stop();
        };
    }
    RolecheckValue(event) {
        if (event.target.checked == true) {
            this.selectedData.push(event.target.datavalue);
            this.selectedDataName.push(event.target.id);
        }
        else {
            const index: number = this.selectedData.indexOf(event.target.datavalue);
            const i1: number = this.selectedDataName.indexOf(event.target.id);
            if (index !== -1) {
                this.selectedData.splice(index, 1);
            }
            if (i1 !== -1) {
                this.selectedDataName.splice(index, 1);
            }
        }
        this.listData = this.selectedData.join(',');
        this.listDataNames = this.selectedDataName.join(',');
    }
    clientCheck(client_id){
        this.spinnerService.start();
        this.sourceTypes  = this.mastersourceTypes;
       // this.sourceType = '';
        if(client_id == 1){
            this.isShowSource = false;
            this.sourceTypes = this.sourceTypes.filter(j=>(j.SubscriptionTypeName != 'Custom' && j.SubscriptionTypeName != 'Raw'))
        }else if(client_id == 2 || client_id == 3){
            this.sourceTypes = this.sourceTypes.filter(j=>(j.SubscriptionTypeName != 'Master' && j.SubscriptionTypeName != 'Raw'))
        }else if(client_id == 4 ){
            this.sourceTypes = this.sourceTypes.filter(j=>(j.SubscriptionTypeName != 'Custom' && j.SubscriptionTypeName != 'Master'))
        }
        this.getFileTypes(client_id);
    }
    ScheduleTypeInitialize() {
        this.http.get('assets/data/frequency.json')
            .subscribe((data) => {
                this.ScheduleType = data;
                // for (let d of data) {
                //     this.ScheduleType.push({ label: d.label, value: d.value });
                // }
            });
    }
    WeekDaysInitialize() {
        this.http.get('assets/data/weekdays.json')
            .subscribe((res) => {
                this.WeekDays = res
                // for (let d of res) {
                //     this.WeekDays.push({ label: d.label, value: d.value });
                // }
            });
    }
    MonthsInitialize() {
        this.http.get('assets/data/months.json')
            .subscribe((data) => {
                this.Months = data;
            });
    }
   
    ScheduleSelection() {
        if (this.selectedType === 'OneTime') {
            this.divDaily = false;
            this.divWeekly = false;
            this.divMonthly = false;
            this.divOneTime = true;
        }
        if (this.selectedType === 'Daily') {
            this.divDaily = true;
            this.divWeekly = false;
            this.divMonthly = false;
            this.divOneTime = false;
        }
        else if (this.selectedType === 'Weekly') {
            this.divDaily = false;
            this.divWeekly = true;
            this.divMonthly = false;
            this.divOneTime = false;
        }
        else if (this.selectedType === 'Monthly') {
            this.divDaily = false;
            this.divWeekly = false;
            this.divMonthly = true;
            this.divOneTime = false;
        }
        this.ScheduleSec();
    }
    ScheduleSec() {
        if (this.selectedType === 'Daily') {
            if (this.selectedDailySchedule !== '') {
                this.selectedWklyWeekDays = [] = ['Sun'];
                this.selectedMonths = [] = ['Jan'];
                this.FinalDeliveryOptions.DailySchedule.FollowingDays.IsSelected = false;
                this.FinalDeliveryOptions.DailySchedule.EveryWeekday.IsSelected = false;
                this.FinalDeliveryOptions.DailySchedule.NumberofDays.IsSelected = false;
                if (this.editForm.value.DailySchedule === 'followingDays') {
                    this.FinalDeliveryOptions.DailySchedule.FollowingDays.IsSelected = true;
                    if (this.selectedDlyWeekDays.length > 0) {
                        this.editForm.value.afterdays = '';
                        this.FinalDeliveryOptions.DailySchedule.FollowingDays.Days = this.selectedDlyWeekDays;
                    }
                }
                if (this.editForm.value.DailySchedule === 'everyWeekday') {
                    this.editForm.value.afterdays = '';
                    this.selectedDlyWeekDays = [] = ['Sun'];
                    this.FinalDeliveryOptions.DailySchedule.EveryWeekday.IsSelected = true;
                }
                if (this.editForm.value.DailySchedule === 'noOfdays') {
                    this.selectedDlyWeekDays = [] = ['Sun'];
                    if (this.editForm.value.afterdays > 0) {
                        this.FinalDeliveryOptions.DailySchedule.NumberofDays.Days = this.editForm.value.afterdays;
                        this.FinalDeliveryOptions.DailySchedule.NumberofDays.IsSelected = true;
                    }
                }
            }
        }
        if (this.selectedType === 'Weekly') {
            this.selectedMonths = [] = ['Jan'];
            this.selectedDlyWeekDays = [] = ['Sun'];
            if (this.selectedWklyWeekDays.length > 0) {
                this.FinalDeliveryOptions.WeeklySchedule.WeekDay = this.selectedWklyWeekDays;
            }
            this.FinalDeliveryOptions.WeeklySchedule.RepeatEveryWk = this.editForm.value.repeatEveryWk;
        }
        if (this.selectedType === 'Monthly') {
            this.selectedDlyWeekDays = [] = ['Sun'];
            this.selectedWklyWeekDays = [] = ['Sun'];
            if (this.selectedMonths.length > 0) {
                this.isMonthCheckValid = false;
            }
            else {
                this.isMonthCheckValid = true;
            }
            if (this.editForm.value.DayOfMonth === 'DayOfMonth') {
                this.FinalDeliveryOptions.MonthlySchedule.DayOfMonth.IsSelected = true;
                this.FinalDeliveryOptions.MonthlySchedule.DayOfMonth.NoDays = this.editForm.value.dayOfMonth;
            }
            this.FinalDeliveryOptions.MonthlySchedule.Months = this.selectedMonths;
        }
        //this.setValidators("Recurring");
        this.FinalDeliveryOptions.FrequencyOptions.Id = this.selectedType;
        if(this.selectedType == 'OneTime'){
            this.FinalDeliveryOptions.FrequencyOptions.Frequency = 'OneTime'
        }else{
            this.FinalDeliveryOptions.FrequencyOptions.Frequency = this.ScheduleType.find(e => e.value == this.selectedType).label;
  
        }
    }
    GetDeliveryOptionsDefaultJSON() {
        this.http.get('assets/data/delivaryoptions.json')
            .subscribe((data) => {
                this.delivaryoptions = data[0];
                this.FinalDeliveryOptions = this.delivaryoptions;
                this.editForm.patchValue({
                   // startDate: this.FinalDeliveryOptions.StartDate,
                  //  endDate: this.FinalDeliveryOptions.EndDate,
                    DailySchedule: this.selectedDailySchedule,
                    Fwd: this.FinalDeliveryOptions.DailySchedule.FollowingDays.Days,
                    afterdays: this.FinalDeliveryOptions.DailySchedule.NumberofDays.Days,
                    repeatEveryWk: this.FinalDeliveryOptions.WeeklySchedule.RepeatEveryWk,
                    dayOfMonth: this.FinalDeliveryOptions.MonthlySchedule.DayOfMonth.IsSelected ? this.FinalDeliveryOptions.MonthlySchedule.DayOfMonth.NoDays : '',
                    DayOfMonth: this.selectedDayOfMonth,
                    Hour: this.FinalDeliveryOptions.Time ? moment(this.FinalDeliveryOptions.Time, 'hh:mm:ss A').format("hh") : "06",
                    Mins: this.FinalDeliveryOptions.Time ? moment(this.FinalDeliveryOptions.Time, 'hh:mm:ss A').format("mm") : "00"
                });
                this.selectedrepeatEveryWk = this.FinalDeliveryOptions.WeeklySchedule.RepeatEveryWk;
               // this.editForm.get('startDate').setValidators([Validators.required]);
               // this.editForm.get('endDate').setValidators(null);
                this.editForm.get('DailySchedule').setValidators(null);
                this.editForm.get('afterdays').setValidators(null);
                this.editForm.get('repeatEveryWk').setValidators(null);
                this.editForm.get('dayOfMonth').setValidators(null);
                this.editForm.get('DayOfMonth').setValidators(null);
                this.editForm.get('Fwd').setValidators(null);
                this.editForm.get('Wds').setValidators(null);
                this.editForm.get('Ms').setValidators(null);
                this.setValidators();
                this.setscheduleOptions();
            });
    }
    setValidators() {
        if (this.selectedType === 'Daily') {
            this.editForm.get('DailySchedule').setValidators([Validators.required]);
            if (this.editForm.value.DailySchedule === 'followingDays') {
                this.editForm.get('Fwd').setValidators([Validators.required]);
                this.editForm.get('afterdays').setValidators(null);
            }
            if (this.editForm.value.DailySchedule === 'everyWeekday') {
                this.editForm.get('Fwd').setValidators(null);
                this.editForm.get('afterdays').setValidators(null);
            }
            if (this.editForm.value.DailySchedule === 'noOfdays') {
                this.editForm.get('Fwd').setValidators(null);
                this.editForm.get('afterdays').setValidators([Validators.required]);
            }
            this.editForm.get('Wds').setValidators(null);
            this.editForm.get('Ms').setValidators(null);
            this.editForm.get('repeatEveryWk').setValidators(null);
            this.editForm.get('dayOfMonth').setValidators(null);
            this.editForm.get('DayOfMonth').setValidators(null);
        }
        else if (this.selectedType === 'Weekly') {
            this.editForm.get('Wds').setValidators([Validators.required]);
            this.editForm.get('repeatEveryWk').setValidators([Validators.required]);
            this.editForm.get('dayOfMonth').setValidators(null);
            this.editForm.get('DayOfMonth').setValidators(null);
            this.editForm.get('Ms').setValidators(null);
            this.editForm.get('DailySchedule').setValidators(null);
            this.editForm.get('Fwd').setValidators(null);
            this.editForm.get('afterdays').setValidators(null);
        }
        else if (this.selectedType === 'Monthly') {
            this.editForm.get('DailySchedule').setValidators(null);
            this.editForm.get('Fwd').setValidators(null);
            this.editForm.get('afterdays').setValidators(null);
            this.editForm.get('Wds').setValidators(null);
            this.editForm.get('Ms').setValidators([Validators.required]);
            this.editForm.get('repeatEveryWk').setValidators(null);
            this.editForm.get('dayOfMonth').setValidators([Validators.required]);
            this.editForm.get('DayOfMonth').setValidators([Validators.required]);
        }
    }
    setscheduleOptions() {
        this.selectedType = this.FinalDeliveryOptions.FrequencyOptions.Frequency;
        if (this.FinalDeliveryOptions.DailySchedule.FollowingDays.IsSelected) {
            this.selectedDlyWeekDays = this.FinalDeliveryOptions.DailySchedule.FollowingDays.Days;
            this.selectedDailySchedule = 'followingDays';
            this.NoOfDays = '';
        }
        else if (this.FinalDeliveryOptions.DailySchedule.EveryWeekday.IsSelected) {
            this.selectedDailySchedule = 'everyWeekday';
        }
        else if (this.FinalDeliveryOptions.DailySchedule.NumberofDays.IsSelected) {
            this.selectedDailySchedule = 'noOfdays';
        }
        this.selectedWklyWeekDays = this.FinalDeliveryOptions.WeeklySchedule.WeekDay;
        this.selectedMonths = this.FinalDeliveryOptions.MonthlySchedule.Months;
        this.selectedDayOfMonth = 'DayOfMonth';
        if (this.selectedType === 'OneTime') {
            this.divDaily = false;
            this.divWeekly = false;
            this.divMonthly = false;
            this.divOneTime = true;
        }
        if (this.selectedType === 'Daily') {
            this.divDaily = true;
            this.divWeekly = false;
            this.divMonthly = false;
            this.divOneTime = false;
        }
        if (this.selectedType === 'Weekly') {
            this.divDaily = false;
            this.divWeekly = true;
            this.divMonthly = false;
            this.divOneTime = false;
        }
        if (this.selectedType === 'Monthly') {
            this.divDaily = false;
            this.divWeekly = false;
            this.divMonthly = true;
            this.divOneTime = false;
        }
        // this.FinalDeliveryOptions.StartDate = moment(this.editForm.value.startDate).format("MM/DD/YYYY");
        // if (this.editForm.value.endDate) {
        //     this.FinalDeliveryOptions.EndDate = moment(this.editForm.value.endDate).format("MM/DD/YYYY");
        // }
        // else {
        //     this.FinalDeliveryOptions.EndDate = "";
        // }

        this.FinalDeliveryOptions.Time = this.editForm.value.Hour + ':' + this.editForm.value.Mins + ':00 ' + this.selectedTime;
        if (this.selectedType === 'Weekly') {
            this.selectedrepeatEveryWk = this.editForm.value.repeatEveryWk;
        }
        else {
            this.selecteddayOfMonth = this.editForm.value.dayOfMonth;
            this.selectedDayOfMonth = this.editForm.value.DayOfMonth;
        }
    }
    dateRangeGet(){
        this.dealerService.dateRangeGet().pipe(first()).subscribe(dateranges => {
            for (let d of dateranges) {
                this.DateRangeOptions.push({ label: d.DateRangeDesc, value: d.DateRangeCode });
            }
            this.editForm.patchValue({
                DateRange : 'Last30Days'
            });
        });
    }
    customSelect(event){
        if(event.value == 'CustomDate'){
            this.isCustomDate = true;
        }else{
            this.isCustomDate = false;
        }
       
    }
    _keyPress(event: any) {
        const pattern = /[0-9\+\-\ ]/;
        let inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    }
    DateValid(val) {
        if (val > 365) {
            (<FormControl>this.editForm.controls['afterdays']).setValue(365);
        }
        if (val < 1) {
            (<FormControl>this.editForm.controls['afterdays']).setValue('');
        }
    }
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
